export const wardRoomOptions = [
  "ICU-101",
  "ICU-102",
  "Ward-A1",
  "Ward-A2",
  "Private-301",
  "General-201"
];

export const procedureOptions = [
  "Appendectomy",
  "Cholecystectomy",
  "Cataract Surgery",
  "Cesarean Section",
  "Heart Bypass Surgery",
  "Knee Replacement",
  "Angioplasty"
];

export const consultantOptions = [
  "Dr. Smith",
  "Dr. Johnson",
  "Dr. Patel",
  "Dr. Lee",
  "Dr. Singh",
  "Dr. Ahmed"
];

export const doctorGroups = {
  Cardiologists: [
    "Dr. John Smith", "Dr. Emily Johnson", "Dr. Michael Brown",
    "Dr. Sarah Davis", "Dr. William Wilson", "Dr. Linda Martinez"
  ],
  Neurologists: [
    "Dr. Robert Lee", "Dr. Patricia Taylor", "Dr. James Anderson",
    "Dr. Barbara Thomas", "Dr. David Jackson", "Dr. Susan White"
  ],
  Orthopedics: [
    "Dr. Richard Garcia", "Dr. Jennifer Harris", "Dr. Charles Clark",
    "Dr. Jessica Lewis", "Dr. Thomas Robinson", "Dr. Karen Walker"
  ],
  Dermatologists: [
    "Dr. Nancy Young", "Dr. Matthew Hall", "Dr. Donna Allen",
    "Dr. Steven King", "Dr. Michelle Wright", "Dr. George Scott"
  ],
  Gynecologists: [
    "Dr. Sandra Green", "Dr. Kevin Adams", "Dr. Laura Baker",
    "Dr. Mark Nelson", "Dr. Angela Carter", "Dr. Brian Mitchell"
  ],
  Pediatricians: [
    "Dr. Melissa Perez", "Dr. Eric Roberts", "Dr. Deborah Turner",
    "Dr. Jason Phillips", "Dr. Rebecca Campbell", "Dr. Andrew Parker"
  ],
  AnaesthesiaSpecialists: [
    "Dr. Anil Mehta", "Dr. Priya Iyer", "Dr. Rakesh Nair",
    "Dr. Neha Sharma", "Dr. Vivek Rao", "Dr. Aarti Desai"
  ]
};

export const nurseGroups = {
  ICU: [
    "Nurse Anna Smith", "Nurse Brian Lee", "Nurse Carol White",
    "Nurse David Green", "Nurse Emma Black", "Nurse Frank Harris",
  ],
  Pediatrics: [
    "Nurse Emily Davis", "Nurse Frank Miller", "Nurse Grace Wilson",
    "Nurse Hannah Moore", "Nurse Ian Clark", "Nurse Julia Lewis",
  ],
  GeneralWard: [
    "Nurse Henry Brown", "Nurse Irene Clark", "Nurse Jack Harris",
    "Nurse Kelly Martinez", "Nurse Liam Thompson", "Nurse Mia Anderson",
  ],
  Emergency: [
    "Nurse Karen Scott", "Nurse Larry Adams", "Nurse Monica Turner",
    "Nurse Nathan Hill", "Nurse Olivia King", "Nurse Peter Wright",
  ],
  Surgery: [
    "Nurse Quinn Young", "Nurse Rachel Walker", "Nurse Samuel Hall",
    "Nurse Tina Allen", "Nurse Victor Baker", "Nurse Wendy Nelson",
  ],
  Maternity: [
    "Nurse Xavier Perez", "Nurse Yolanda Roberts", "Nurse Zoe Campbell",
    "Nurse Aaron Phillips", "Nurse Bethany Parker", "Nurse Chris Turner",
  ],
};
